<template>
  <div
    class="flex max-w-full flex-col space-y-6 p-6 text-ontick-carbon-900 dark:text-gray-300 sm:flex-row sm:space-y-0 sm:space-x-6"
    v-if="data"
  >
    <i v-html="$icons.warning_lg"></i>
    <div class="flex flex-col space-y-6">
      <div class="flex flex-col space-y-2">
        <p class="text-2xl font-bold sm:text-3xl">Downgrade de plano</p>
        <div class="flex items-center space-x-2">
          <ontick-plan-logo-component :plan="getUserPlan.plan_name" />
          <span> > </span>
          <ontick-plan-logo-component plan="BASIC" />
        </div>
        <p class="text-ontick-yellow-800 dark:text-ontick-yellow-700">
          Atenção! Antes de prosseguir, leia atentamente as informações abaixo.
        </p>
      </div>
      <div
        class="flex max-w-full flex-col-reverse sm:flex-row sm:space-y-0 sm:space-x-6"
      >
        <div class="flex flex-col space-y-6 pt-6 sm:pt-0">
          <p>
            Ao realizar esta ação seu plano
            <span class="font-bold">
              {{ getUserPlan && getUserPlan.plan_name.replaceAll("_", " ") }}
            </span>
            não será renovado e, por conta disso, você perderá algumas
            funcionalidades.
          </p>
          <p>
            Seu plano
            {{ getUserPlan && getUserPlan.plan_name.replaceAll("_", " ") }} é
            válido até o dia
            <span class="font-bold">{{
              moment(data.license_expiration_date).format("DD/MM/YYYY")
            }}</span
            >, após esta data, será alterado para o BASIC.
          </p>
          <p>
            Após esta data (<span class="font-bold"
              >{{
                moment(data.license_expiration_date).format("DD/MM/YYYY")
              }} </span
            >) TODOS os seus investimentos serão desligados automaticamente para
            que a troca de planos seja feita. Você poderá ligá-los novamente
            seguindo os limites do seu novo plano
          </p>
          <div class="flex items-center space-x-2">
            <input
              type="checkbox"
              v-model="readConfirmation"
              id="confirmation"
              name="confirmation"
              class="h-4 w-4 rounded border-none bg-ontick-steel-300 text-ontick-blue-600 dark:bg-ontick-steel-500"
            />
            <label
              for="confirmation"
              class="text-xs text-gray-500 dark:text-gray-400"
            >
              Confirmo que li as informações acima e desejo realizar o downgrade
              do meu plano.
            </label>
          </div>
          <div
            class="flex w-full flex-col items-center justify-end space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4"
          >
            <ontick-button
              color="transparent"
              class="w-full sm:w-min"
              @click.native="$router.push({ path: 'account?tag=plans' })"
              >Cancelar</ontick-button
            >
            <ontick-button
              color="red"
              class="w-full whitespace-nowrap sm:w-min"
              :disabled="!readConfirmation"
              @click.native="cancelPlan"
            >
              <i
                v-html="$icons.loading"
                class="text-gray-300"
                v-if="cancellationIsLoading"
              ></i>
              <span v-else> Fazer downgrade </span>
            </ontick-button>
          </div>
        </div>
        <div
          class="flex w-full flex-col divide-y divide-ontick-steel-500 rounded-lg border-2 border-ontick-steel-300 p-6 dark:border-none dark:bg-ontick-graphite-500"
        >
          <p class="pb-6 text-2xl font-bold">
            Funcionalidades que serão perdidas
          </p>
          <ul class="space-y-4 py-6">
            <li>
              <p>
                Acesso às estratégias de nível
                {{ getUserPlan.plan_name.replaceAll("_", " ").split(" ")[0] }};
              </p>
            </li>
            <li>
              <p>
                Extensões exclusivas para assinantes
                {{ getUserPlan.plan_name.replaceAll("_", " ").split(" ")[0] }};
              </p>
            </li>
            <li class="space-y-2">
              <p>Limite de estratégias em produção;</p>
              <div class="flex items-center space-x-2">
                <i v-html="$icons.close_red"></i>
                <div
                  class="flex items-center space-x-2 text-xs font-normal text-gray-500 dark:text-gray-400"
                >
                  <span class="font-bold line-through">
                    {{ canBeNegative(data.prd_execs.curr_plan) }}
                  </span>
                  <span> > </span>
                  <span> {{ data.prd_execs.new_plan }} </span>
                </div>
              </div>
            </li>
            <li class="space-y-2">
              <p>Limite de estratégias em demo;</p>
              <div class="flex items-center space-x-2">
                <i v-html="$icons.close_red"></i>
                <div
                  class="flex items-center space-x-2 text-xs font-normal text-gray-500 dark:text-gray-400"
                >
                  <span class="font-bold line-through">
                    {{ canBeNegative(data.demo_execs.curr_plan) }}
                  </span>
                  <span> > </span>
                  <span> {{ data.demo_execs.new_plan }} </span>
                </div>
              </div>
            </li>
            <li class="space-y-2">
              <p>Limite de minicontratos operados;</p>
              <div class="flex items-center space-x-2">
                <i v-html="$icons.close_red"></i>
                <div
                  class="flex items-center space-x-2 text-xs font-normal text-gray-500 dark:text-gray-400"
                >
                  <span class="font-bold line-through">
                    {{ canBeNegative(data.max_lots.curr_plan) }}
                  </span>
                  <span> > </span>
                  <span> {{ data.max_lots.new_plan }} </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ontickPlanLogoComponent from "../../../shared/components/basic/ontick-plan-logo.component.vue";
export default {
  components: { ontickPlanLogoComponent },

  data() {
    return {
      data: null,
      readConfirmation: false,
      cancellationIsLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      getUserPlan: "config/getUserPlan",
    }),
  },

  methods: {
    ...mapActions({
      setUserConfig: "config/setUserConfig",
      fetchAccounts: "accountTypes/fetchAccounts",
    }),
    getConfig() {
      return new Promise((resolve, reject) => {
        this.$api
          .get(this.$endpoint.USER_CONFIGS)
          .then((response) => {
            this.setUserConfig(response.data);
            this.fetchAccounts(response.data.accounts);
            resolve();
          })
          .catch((error) => {
            if (error.data.status == "error") {
              this.setUserConfig(error.data);
            }
            reject();
          });
      });
    },
    cancelPlan() {
      this.cancellationIsLoading = true;
      this.$api
        .post(this.$endpoint.CANCEL_ACTIVE_SUBSCRIPTION, {
          license_id: this.data.user_license_id,
        })
        .then(() => {
          this.cancellationIsLoading = false;
          this.$swal({
            title: "Plano cancelado",
            text: "Você ainda poderá desfrutar dos benefícios do seu plano até a data de vencimento.",
            icon: "success",
            iconHtml: this.$icons.swal_success,
          }).then(() => {
            this.getConfig()
              .then(() => {
                this.$router.push("/account?tag=plans");
              })
              .catch((err) => {
                console.error(err);
              });
          });
        })
        .catch((err) => {
          this.cancellationIsLoading = false;
          this.$swal("Erro", err.data.msg, "error");
        });
    },
    canBeNegative(value) {
      return value === -1 ? "Ilimitado" : value;
    },
    getInfo() {
      this.$api
        .get(this.$endpoint.GET_INVOICE_INFO, {
          params: {
            invoice_type: "PLAN",
            plan_id: 2,
          },
        })
        .then((res) => {
          this.data = res.data;
        })
        .catch((err) => {
          this.$swal("Erro", err.data.msg, "error");
        });
    },
  },

  created() {
    this.getInfo();
  },
};
</script>

<style lang="scss" scoped>
ul {
  @apply list-disc pl-4;
  li {
    @apply text-xs font-bold;
  }
}
</style>
